import React, { Component } from 'react';
import { connect } from 'react-redux';
import PluginView from './Plugin.view';

export class PluginContainer extends Component {
  constructor(props){
    super(props);
    this.logout = this.logout.bind(this);
  }
  logout(){
    const { dispatch, history } = this.props;
    dispatch({
      $global: true,
      type: 'LOGOUT',
      meta: {
        history: history,
      }
    });
  }
  render() {
    return (<PluginView
      {...this.props}
      logout={this.logout}
    />);
  }

}

function mapStateToProps(state) {
  return {
  };
}

export default connect(mapStateToProps)(PluginContainer);



// WEBPACK FOOTER //
// ./src/app/modules/Plugin/Plugin.container.js